import React from 'react'
// import useData from '../hooks/useData'
import ArticleResourcesColumn from './ArticleResourcesColumn'
import ArticleResourcesContent from './ArticleResourcesContent'
import GoogleSearchForResources from './GoogleSearchForResources'

const ArticleResources = props => {
    const article_id = props.article_id || (props.match && props.match.params && props.match.params.article_id) || false
    // const articleData = useData(
    //     {
    //         url: 'article/' + article_id,
    //         transform: data => ({
    //             ...data,
    //             resources: (data.resources && JSON.parse(data.resources)) || null
    //         })
    //     },
    //     [article_id]
    // )
    return (
        <>
            <ArticleResourcesContent origin={'google'}>
                <div className='row'>
                    <div className='col-md-9 col-xxl-7'>
                        <GoogleSearchForResources origin='google' target_article={!!article_id} />
                    </div>
                    <div className='col-md-3 col-xxl-5'>
                        <ArticleResourcesColumn grabText={true} />
                    </div>
                </div>
            </ArticleResourcesContent>
        </>
    )
}

export default ArticleResources
